import { render } from "./DefinitionsPage.vue?vue&type=template&id=2c289490"
import script from "./DefinitionsPage.vue?vue&type=script&lang=js"
export * from "./DefinitionsPage.vue?vue&type=script&lang=js"

import "./DefinitionsPage.vue?vue&type=style&index=0&id=2c289490&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__